import properCase from "./properCase";

export function recordTypeName(recordType: string): string {
  return properCase(recordType);
}

export const recordTypes = {
  locations: "basic",
  items: "basic",
  vendors: "basic",
  customers: "basic",
  inventoryOnHand: "basic",
  storeCredits: "basic",
  giftCards: "basic",
  customFields: "basic",
  customBranding: "advanced",
  companyDetails: "basic",
  customerNotes: "basic",
  settings: "basic",
  purchaseOrders: "advanced",
  salesHistory: "advanced",
  customPaymentTypes: "advanced",
  reasonCodes: null,
  savedReports: null,
  users: null,
  gridTemplates: null,
  roles: null,
  templates: null,
  copyTenantToProduction: null,
  featureFlags: null,
};

function recordTypesByMigrationType(migrationType: string): string[] {
  const migrationTypes = [migrationType];
  if (migrationType === "advanced") {
    migrationTypes.push("basic");
  }
  if (migrationType === "all") {
    migrationTypes.push(null);
  }
  return Object.keys(recordTypes).filter((key) =>
    migrationTypes.includes(recordTypes[key])
  );
}

export const basicMigrationRecordTypes = recordTypesByMigrationType("basic");
export const advancedMigrationRecordTypes = recordTypesByMigrationType(
  "advanced"
);
